module.exports = __webpack_public_path__ + "static/managealerts-4f113381660d2654ab40b959d7cde11b.png";